export default __webpack_public_path__ + "images/change_flight.672af1b.png";